"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconJumpToContent', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M5 3C5 2.44772 4.55228 2 4 2C3.44772 2 3 2.44772 3 3V11C3 11.5523 3.44772 12 4 12H9.58578L8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L12.7071 11.7071C12.8946 11.5196 13 11.2652 13 11C13 10.7348 12.8946 10.4804 12.7071 10.2929L9.70711 7.29289C9.31658 6.90237 8.68342 6.90237 8.29289 7.29289C7.90237 7.68342 7.90237 8.31658 8.29289 8.70711L9.58579 10H5V3Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M6 3C6 2.44772 5.55228 2 5 2C4.44772 2 4 2.44772 4 3V13C4 13.5523 4.44772 14 5 14H12.5858L10.2929 16.2929C9.90237 16.6834 9.90237 17.3166 10.2929 17.7071C10.6834 18.0976 11.3166 18.0976 11.7071 17.7071L15.7064 13.7078C15.7088 13.7054 15.7112 13.703 15.7136 13.7005C15.8063 13.6062 15.8764 13.498 15.9241 13.3828C15.9727 13.2657 15.9996 13.1375 16 13.003L16 13L16 12.997C15.9992 12.7254 15.8901 12.4792 15.7136 12.2995C15.7112 12.297 15.7088 12.2946 15.7064 12.2922L11.7071 8.29289C11.3166 7.90237 10.6834 7.90237 10.2929 8.29289C9.90237 8.68342 9.90237 9.31658 10.2929 9.70711L12.5858 12H6V3Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M7 3C7 2.44772 6.55228 2 6 2C5.44772 2 5 2.44772 5 3V16C5 16.5523 5.44772 17 6 17H15.5858L12.7929 19.7929C12.4024 20.1834 12.4024 20.8166 12.7929 21.2071C13.1834 21.5976 13.8166 21.5976 14.2071 21.2071L18.7064 16.7078C18.7088 16.7054 18.7112 16.703 18.7136 16.7005C18.8063 16.6062 18.8764 16.498 18.9241 16.3828C18.9727 16.2657 18.9996 16.1375 19 16.003C19 16.002 19 16.001 19 16C19 15.999 19 15.998 19 15.997C18.9992 15.7254 18.8901 15.4792 18.7136 15.2995C18.7112 15.297 18.7088 15.2946 18.7064 15.2922L14.2071 10.7929C13.8166 10.4024 13.1834 10.4024 12.7929 10.7929C12.4024 11.1834 12.4024 11.8166 12.7929 12.2071L15.5858 15H7V3Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M9 4.5C9 3.67157 8.32843 3 7.5 3C6.67157 3 6 3.67157 6 4.5V21.5C6 22.3284 6.67157 23 7.5 23H20.8787L17.4393 26.4393C16.8536 27.0251 16.8536 27.9749 17.4393 28.5607C18.0251 29.1464 18.9749 29.1464 19.5607 28.5607L25.5607 22.5607C26.1464 21.9749 26.1464 21.0251 25.5607 20.4393L19.5607 14.4393C18.9749 13.8536 18.0251 13.8536 17.4393 14.4393C16.8536 15.0251 16.8536 15.9749 17.4393 16.5607L20.8787 20H9V4.5Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;